// extracted by mini-css-extract-plugin
module.exports = {"colors-item":"ColorList_colors-item__2rv5B"};